module.exports = __webpack_public_path__ + "static/media/bg10.463b2448.jpg";